import React, { useEffect, useState } from "react";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Link } from "react-router-dom";
import axios from "../../../api/axios";
import { useAuth } from "../../../hooks/useAuth";
import DataLoader from "../../../components/DataLoader";
import { FaBackspace } from "react-icons/fa";

const Index = () => {
  const { auth } = useAuth();
  const [centerAnalytics, setCenterAnalytics] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(true);
  const [studentData, setStudentData] = useState([]);
  const [inputVal, setInputVal] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const { data: allStudents } = studentData;

  const [filters, setFilters] = useState({
    email: "",
    start_date: "",
    end_date: "",
    status: "",
    phone: "",
  });

  const { email, start_date, end_date, status, phone } = filters;

  async function getCenterAnalytics() {
    setIsLoading(true);
    try {
      const response = await axios.get(`center-analytics`, {
        headers: {
          "X-Center-Token": `${auth.access_token}`,
        },
      });
      setCenterAnalytics(response?.data);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function getCenterStudents() {
    setIsFetching(true);
    try {
      const response = await axios.get(
        `cbt-center/students?email=${email}&date_from=${start_date}&date_to=${end_date}&phone=${phone}&status=${
          status === "all" ? "" : status
        }`,
        {
          headers: {
            "X-Center-Token": `${auth.access_token}`,
          },
        }
      );
      setStudentData(response?.data);
      setIsFetching(false);
    } catch (err) {
      console.log(err);
    }
  }
  useEffect(() => {
    getCenterAnalytics();
  }, []);

  useEffect(() => {
    getCenterStudents();
  }, [email, start_date, end_date, status, phone]);

  function filterUserByEmail() {
    if (!inputVal) {
      alert("Kindly provide an email address");
      return;
    }

    setFilters((prev) => ({ ...prev, email: inputVal }));
  }

  function filterUserByPhoneNumber() {
    if (!phoneNumber) {
      alert("Kindly provide a phone number");
      return;
    }

    setFilters((prev) => ({ ...prev, phone: phoneNumber }));
  }

  function clearEmailFilter() {
    setInputVal("");
    setFilters((prev) => ({ ...prev, email: "" }));
  }

  function clearPhoneFilter() {
    setPhoneNumber("");
    setFilters((prev) => ({ ...prev, phone: "" }));
  }

  function filterAllUsersByDateRange(event, picker) {
    const startDate = picker.startDate._d.toLocaleDateString("fr-CA").replace(/\//g, "-");
    const endDate = picker.endDate._d.toLocaleDateString("fr-CA").split("/").join("-");

    setFilters((prev) => ({ ...prev, start_date: startDate, end_date: endDate }));
  }

  const filterAllSubscriptionsByStatus = (active_status) => {
    setFilters((prev) => ({ ...prev, status: active_status }));
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Dashboard</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li class="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>

        <div class="col-xl-12">
          <div class="card crm-widget">
            <div class="card-body p-0">
              <div class="row row-cols-md-3 row-cols-1">
                {/* end col */}
                <div class="col col-lg border-end">
                  <div class="mt-3 mt-md-0 py-4 px-3">
                    <h5 class="text-muted text-uppercase fs-13">
                      New Students <i class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                    </h5>
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        <i class="ri-account-circle-line display-6 text-muted"></i>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h2 class="mb-0">
                          <span class="counter-value" data-target="32.89">
                            {isLoading ? "?" : centerAnalytics?.new_students?.length}
                            {/* {centerAnalytics?.new_students?.length} */}
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end col */}
                <div class="col col-lg border-end">
                  <div class="py-4 px-3">
                    <h5 class="text-muted text-uppercase fs-13">
                      Total Students <i class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                    </h5>
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        <i class="ri-account-circle-line display-6 text-muted"></i>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h2 class="mb-0">
                          <span class="counter-value" data-target="197">
                            {isLoading ? "?" : centerAnalytics?.students_count}
                            {/* {centerAnalytics?.students_count} */}
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end col */}
                {/* <div class="col col-lg border-end">
                  <div class="mt-3 mt-md-0 py-4 px-3">
                    <h5 class="text-muted text-uppercase fs-13">
                      Total Income{" "}
                      <i class="ri-arrow-up-circle-line text-success fs-18 float-end align-middle"></i>
                    </h5>
                    <div class="d-flex align-items-center">
                      <div class="flex-shrink-0">
                        <i class="ri-exchange-dollar-line display-6 text-muted"></i>
                      </div>
                      <div class="flex-grow-1 ms-3">
                        <h2 class="mb-0">
                          &#x20A6;
                          <span class="counter-value" data-target="489.4">
                            {isLoading ? "?" : centerAnalytics?.total_income}
                           
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div> */}
                <div class="col col-lg border-end">
                  <div class="mt-3 mt-lg-0 py-4 px-3">
                    <h5 class="text-muted text-uppercase fs-13">
                      Referral code{" "}
                      {/* <i class="ri-exchange-dollar-line text-success fs-18 float-end align-middle"></i> */}
                    </h5>
                    <div class="d-flex align-items-center">
                      {/* <div class="flex-shrink-0">
                        <i class="ri-space-ship-line display-6 text-muted"></i>
                      </div> */}
                      <div class="flex-grow-1 mt-2">
                        <h2 class="mb-0">
                          <span class="counter-value" data-target="1596.5">
                            {isLoading ? "?" : centerAnalytics?.referal_code}
                            {/* {centerAnalytics?.referal_code} */}
                          </span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end col */}
                {/* <div class="col col-lg">
                                            <div class="mt-3 mt-lg-0 py-4 px-3">
                                                <h5 class="text-muted text-uppercase fs-13">
                                                    Annual Deals <i class="ri-arrow-down-circle-line text-danger fs-18 float-end align-middle"></i>
                                                </h5>
                                                <div class="d-flex align-items-center">
                                                    <div class="flex-shrink-0">
                                                        <i class="ri-service-line display-6 text-muted"></i>
                                                    </div>
                                                    <div class="flex-grow-1 ms-3">
                                                        <h2 class="mb-0"><span class="counter-value" data-target="2659">0</span></h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                {/* end col */}
              </div>
              {/* end row */}
            </div>
            {/* end card body */}
          </div>
          {/* end card */}
        </div>
        {/* end col */}
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <div className="">
                <h5 className="fw-bold">Filter By:</h5>
                <div className="row">
                  <div className="col-md-7 mb-3">
                    <label for="email" className="form-label">
                      Email
                    </label>
                    <div>
                      <input
                        type="email"
                        className="form-control"
                        style={{ position: "relative" }}
                        value={inputVal}
                        onChange={(e) => setInputVal(e.target.value)}
                      />
                      {inputVal && (
                        <button
                          style={{
                            position: "absolute",
                            top: "31px",
                            right: "65px",
                            fontSize: "14px",
                            color: "#fff",
                            backgroundColor: "#405189",
                            borderColor: "#405189",
                            outline: "none",
                            border: "1px solid transparent",
                            borderRadius: "0.25rem",
                            paddingRight: "10px",
                            paddingLeft: "10px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                          onClick={clearEmailFilter}
                        >
                          Clear <FaBackspace />
                        </button>
                      )}
                      <button
                        style={{
                          position: "absolute",
                          top: "31px",
                          right: "15px",
                          fontSize: "16px",
                          color: "#fff",
                          backgroundColor: "#405189",
                          borderColor: "#405189",
                          outline: "none",
                          border: "1px solid transparent",
                          borderRadius: "0.25rem",
                          paddingRight: "15px",
                          paddingLeft: "15px",
                        }}
                        onClick={filterUserByEmail}
                      >
                        <i className="ri-search-line search-icon"></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label for="email" className="form-label">
                      Phone Number
                    </label>
                    <div>
                      <input
                        type="tel"
                        className="form-control"
                        style={{ position: "relative" }}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                      />
                      {phoneNumber && (
                        <button
                          style={{
                            position: "absolute",
                            top: "31px",
                            right: "65px",
                            fontSize: "14px",
                            color: "#fff",
                            backgroundColor: "#405189",
                            borderColor: "#405189",
                            outline: "none",
                            border: "1px solid transparent",
                            borderRadius: "0.25rem",
                            paddingRight: "10px",
                            paddingLeft: "10px",
                            paddingTop: "4px",
                            paddingBottom: "4px",
                          }}
                          onClick={clearPhoneFilter}
                        >
                          Clear <FaBackspace />
                        </button>
                      )}
                      <button
                        style={{
                          position: "absolute",
                          top: "30px",
                          right: "15px",
                          fontSize: "16px",
                          color: "#fff",
                          backgroundColor: "#405189",
                          borderColor: "#405189",
                          outline: "none",
                          border: "1px solid transparent",
                          borderRadius: "0.25rem",
                          paddingRight: "15px",
                          paddingLeft: "15px",
                        }}
                        onClick={filterUserByPhoneNumber}
                      >
                        <i className="ri-search-line search-icon"></i>
                      </button>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label for="" className="form-label">
                      Status
                    </label>
                    <select
                      name=""
                      id=""
                      className="form-select"
                      value={status}
                      onChange={(e) => filterAllSubscriptionsByStatus(e.target.value)}
                    >
                      <option value="all" selected>
                        All
                      </option>
                      <option value="1">Active</option>
                      <option value="0">Not Active</option>
                    </select>
                  </div>

                  <div className="col-md-3">
                    <label for="date-range" className="form-label">
                      Date Range
                    </label>

                    <DateRangePicker
                      initialSettings={{
                        startDate: "1/1/2021",
                        endDate: "1/14/2021",
                      }}
                      onApply={filterAllUsersByDateRange}
                    >
                      <input type="text" className="form-control" />
                    </DateRangePicker>
                  </div>
                </div>
              </div>
            </div>
            {/* end card header */}

            <div className="card-body">
              <div className="live-preview">
                <div className="table-responsive">
                  <table className="table align-middle table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th scope="col" style={{ width: "42px" }}>
                          S/N
                        </th>

                        <th scope="col">Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">Phone Number</th>
                        <th scope="col">Class Level</th>
                        <th scope="col">Status</th>
                        <th scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching && (
                        <tr>
                          <DataLoader />
                        </tr>
                      )}
                      {!isFetching && allStudents?.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center py-3">
                            No Result Found
                          </td>
                        </tr>
                      )}

                      {!isFetching &&
                        allStudents &&
                        allStudents?.length !== 0 &&
                        allStudents?.map((eachStudent, i) => (
                          <tr key={eachStudent?.uuid}>
                            <th scope="row">{i + 1}</th>

                            <td style={{ textTransform: "capitalize" }}>
                              {eachStudent?.is_center_account === 1
                                ? `${eachStudent?.first_name}`
                                : `${eachStudent?.first_name} ${eachStudent?.last_name}`}
                            </td>
                            <td>
                              <a href="#" className="fw-medium">
                                {eachStudent?.email}
                              </a>
                            </td>

                            <td>{eachStudent?.phone}</td>
                            <td>{eachStudent?.class_level || "-"}</td>
                            <td>
                              {eachStudent?.status === 1 ? (
                                <span className="text-success">
                                  <i className="ri-checkbox-circle-line fs-17 align-middle"></i> Active
                                </span>
                              ) : (
                                <span className="text-danger">
                                  <i className="ri-checkbox-circle-line fs-17 align-middle"></i> Not Active
                                </span>
                              )}
                            </td>
                            <td>
                              <Link to={`student/${eachStudent?.uuid}`} state={{ student: eachStudent }}>
                                View details
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  {/* end table */}

                  {!isFetching && allStudents?.length !== 0 && (
                    <div className="d-flex justify-content-end mt-3">
                      <div className="pagination-wrap hstack gap-2">
                        <button
                          className="page-item pagination-prev"
                          // onClick={getPreviousUsers}
                        >
                          &laquo;
                        </button>
                        <ul className="pagination  mb-0">Page 1 of 1</ul>
                        <button
                          className="page-item pagination-next"
                          // onClick={getNextUsers}
                        >
                          &raquo;
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                {/* end table responsive */}
              </div>
            </div>
            {/* end card-body */}
          </div>
          {/* end card */}
        </div>
        {/* end col */}
      </div>
    </div>
  );
};

export default Index;
